import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `@wit-support/ui/charts` — графики кита (Recharts 3), отдельный вход пакета.
 *
 * Компоненты отсюда ЛЕНИВЫЕ: этот файл `recharts` не импортирует, реализация
 * (`./impl.tsx`) грузится динамическим `import()` при первом показе любого
 * графика, а пока грузится — заглушка той же высоты. Экрану не нужен свой
 * `React.lazy`: статический импорт `@wit-support/ui/charts` дешёвый, Recharts
 * уезжает в отдельный чанк сборщика.
 *
 * Цвета — только токены темы (`--color-chart-N`, `--color-network-*-solid`,
 * `--color-state-*-solid`), подписи и числа — по-русски.
 */
import * as React from 'react';
import { ChartSkeleton } from './chart-parts.js';
export * from './types.js';
export { formatChartAxisLabelRu, formatChartTickRu, formatChartTooltipLabelRu, formatChartValueRu, } from './format.js';
export { ChartLegend, ChartSkeleton, ChartSwatch, ChartTooltipContent, } from './chart-parts.js';
let implPromise = null;
/**
 * Загрузить модуль графиков заранее (например, при наведении на ссылку
 * экрана с графиками). Повторные вызовы — тот же промис.
 */
export function preloadCharts() {
    implPromise ??= import('./impl.js');
    return implPromise;
}
function lazyChart(pick, displayName, fallbackHeight = (props) => (props.height ?? 240) + 24) {
    const Lazy = React.lazy(() => preloadCharts().then((m) => ({ default: pick(m) })));
    function Chart(props) {
        return (_jsx(React.Suspense, { fallback: _jsx(ChartSkeleton, { height: fallbackHeight(props), className: props.className }), children: _jsx(Lazy, { ...props }) }));
    }
    Chart.displayName = displayName;
    return Chart;
}
/** Линии по времени: просмотры по дням по сетям, рост просмотров по возрасту. */
export const LineChart = lazyChart((m) => m.LineChartImpl, 'LineChart', 
// Мини-график без легенды — заглушка ровно его высоты.
(props) => (props.sparkline ? (props.height ?? 32) : (props.height ?? 240) + 24));
/** Площади (в т.ч. стопкой): доли целого во времени. */
export const AreaChart = lazyChart((m) => m.AreaChartImpl, 'AreaChart');
/** Столбцы/полосы, в т.ч. стопкой: публикации и залёты по неделям, сила по сетям. */
export const BarChart = lazyChart((m) => m.BarChartImpl, 'BarChart');
/** Столбики и линии на одной оси X, правая ось у рядов `axis: 'right'`: расход и покупки. */
export const ComposedChart = lazyChart((m) => m.ComposedChartImpl, 'ComposedChart');
/** Точки: две меры одной сущности (просмотры × кратность клипа). */
export const ScatterChart = lazyChart((m) => m.ScatterChartImpl, 'ScatterChart');
//# sourceMappingURL=index.js.map